import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

interface MedalStarProps extends SvgIconProps {
  size?: number;
}

const MedalStar: React.FC<MedalStarProps> = ({ size = 16, ...props }) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      sx={{
        width: size,
        height: size,
        ...props.sx,
      }}
    >
      <path
        opacity="0.4"
        d="M12.6666 5.99967C12.6666 6.96634 12.38 7.85302 11.8866 8.59302C11.1666 9.65968 10.0266 10.413 8.69998 10.6063C8.47331 10.6463 8.23998 10.6663 7.99998 10.6663C7.75998 10.6663 7.52665 10.6463 7.29998 10.6063C5.97331 10.413 4.83331 9.65968 4.11331 8.59302C3.61998 7.85302 3.33331 6.96634 3.33331 5.99967C3.33331 3.41967 5.41998 1.33301 7.99998 1.33301C10.58 1.33301 12.6666 3.41967 12.6666 5.99967Z"
        fill="#3E8D7B"
      />
      <path
        d="M14.1666 12.3129L13.0666 12.5729C12.82 12.6329 12.6266 12.8196 12.5733 13.0663L12.34 14.0463C12.2133 14.5796 11.5333 14.7396 11.18 14.3196L7.99997 10.6663L4.81997 14.3263C4.46664 14.7463 3.78664 14.5863 3.65997 14.0529L3.42664 13.0729C3.36664 12.8263 3.1733 12.6329 2.9333 12.5796L1.8333 12.3196C1.32664 12.1996 1.14664 11.5663 1.5133 11.1996L4.1133 8.59961C4.8333 9.66628 5.9733 10.4196 7.29997 10.613C7.52664 10.653 7.75997 10.673 7.99997 10.673C8.23997 10.673 8.47331 10.653 8.69997 10.613C10.0266 10.4196 11.1666 9.66628 11.8866 8.59961L14.4866 11.1996C14.8533 11.5596 14.6733 12.1929 14.1666 12.3129Z"
        fill="#3E8D7B"
      />
      <path
        d="M8.38669 3.98699L8.78002 4.77365C8.83336 4.88032 8.97336 4.98699 9.10002 5.00699L9.81336 5.12699C10.2667 5.20032 10.3734 5.53366 10.0467 5.86032L9.49336 6.41365C9.40002 6.50698 9.34669 6.68699 9.38002 6.82033L9.54002 7.50699C9.66669 8.04699 9.38002 8.26031 8.90002 7.97365L8.23336 7.58031C8.11336 7.50698 7.91336 7.50698 7.79336 7.58031L7.12669 7.97365C6.64669 8.25364 6.36002 8.04699 6.48669 7.50699L6.64669 6.82033C6.67336 6.69366 6.62669 6.50698 6.53336 6.41365L5.98002 5.86032C5.65336 5.53366 5.76002 5.20699 6.21336 5.12699L6.92669 5.00699C7.04669 4.98699 7.18669 4.88032 7.24002 4.77365L7.63336 3.98699C7.82669 3.56033 8.17336 3.56033 8.38669 3.98699Z"
        fill="#3E8D7B"
      />
    </SvgIcon>
  );
};

export default MedalStar;
